// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__WTksJ","importantInfo":"styles_importantInfo__26W5k"};